import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CartItem } from "../interfaces/cart";

interface CartState {
    description: string;
    items: CartItem[];
}

const initialState: CartState = {
    description: "Purchase",
    items: [],
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addItem: (state, action: PayloadAction<CartItem>) => {
            state.items.push(action.payload);
        },
        //removeItem: (state, action: PayloadAction<number>) => {
        //    state.items = state.items.filter(item => item.programId !== action.payload);
        //},
        clearCart: (state) => {
            state.items = [];
        },
        setCart: (state, action: PayloadAction<CartState>) => {
            return action.payload;
        },
    },
});

// Selector to get the total price of all items in the cart
export const selectTotalPrice = createSelector(
    (state: CartState) => state.items,
    (items) => items.reduce((total, item) => total + item.price, 0),
);

export const {
    addItem,
    setCart,
    clearCart,
} = cartSlice.actions;
export default cartSlice.reducer;
